import { makeStyles, useTheme } from '@material-ui/core';
import classnames from 'classnames';
import PropTypes from 'prop-types';
import * as React from 'react';
const useStyles = makeStyles((theme) => ({
  root: {
    userSelect: 'none',
    width: '1em',
    height: '1em',
    display: 'inline-block',
    fill: 'currentColor',
    flexShrink: 0,
    transition: theme.transitions.create('fill', {
      duration: theme.transitions.duration.shorter,
    }),
  },
}));

function SvgBasicTenancyShorten({ svgRef, ...props }) {
  const classes = useStyles();
  const theme = useTheme();
  const { color, className } = props;
  return (
    <svg
      {...props}
      viewBox="0 0 16 16"
      className={classnames(classes.root, className)}
      color={theme.colors[color] ?? color}
      ref={svgRef}
    >
      <path
        d="M12.84 4.39l.09.08.07.08c.2.26.2.62.01.89l-.08.09-1.72 1.72h4.04a.75.75 0 110 1.5h-4.04l1.72 1.72.07.08a.75.75 0 01-1.05 1.05l-.08-.07-3-3-.07-.08a.75.75 0 01-.01-.89l.08-.09 3-3 .08-.07c.26-.2.62-.2.89-.01zm-8.8 0l.09.08 3 3c.27.27.3.68.07.98l-.07.08-3 3A.75.75 0 013 10.55l.07-.08 1.72-1.72H.75a.75.75 0 010-1.5h4.04L3.07 5.53A.75.75 0 013 4.55l.07-.08a.75.75 0 01.98-.07z"
        fillRule="evenodd"
      />
    </svg>
  );
}

SvgBasicTenancyShorten.propTypes = {
  svgRef: PropTypes.any,
  className: PropTypes.string,
  color: PropTypes.string,
  fontSize: PropTypes.any,
};
SvgBasicTenancyShorten.defaultProps = {
  svgRef: undefined,
  className: undefined,
  color: undefined,
  fontSize: 16,
};
const ForwardRef = React.forwardRef((props, ref) => (
  <SvgBasicTenancyShorten svgRef={ref} {...props} />
));
export default ForwardRef;
